import { render, staticRenderFns } from "./CenteredImage.vue?vue&type=template&id=9c9082f0&scoped=true&"
import script from "./CenteredImage.vue?vue&type=script&lang=js&"
export * from "./CenteredImage.vue?vue&type=script&lang=js&"
import style0 from "./CenteredImage.vue?vue&type=style&index=0&id=9c9082f0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9c9082f0",
  null
  
)

export default component.exports